import React, { useEffect } from 'react';
import '../application/header/appHeader.scss';
import { useIntl } from 'react-intl';
import AppHeaderLeftContainer from '../application/header/AppHeaderLeftContainer';
import AppHeaderRightContainer from './AppHeaderRightContainer';

export function AppHeader() {
  const intl = useIntl();

  useEffect(() => {
    document.title = intl.formatMessage({ id: 'app.title' });
  }, [intl]);

  return (
    <div id="header">
      <AppHeaderLeftContainer />
      <AppHeaderRightContainer />
    </div>
  );
}
